import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";
import { MobileOperatingSystem } from "../../../../Utils/getMobileOperatingSystem";

interface OsProps {
  $os: MobileOperatingSystem;
}

export const _LandingInnovationUmamiRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
}>(() => {
  return css`
    padding: 56px 46px;
    background-color: #0b0b0c;
    position: relative;

    @media ${responsiveMap.mobile} {
      padding: 0px;
    }
  `;
});

export const _LandingInnovationUmamiProductList = styled("div")<
  {
    $isList?: boolean;
    $itemFullWidth?: boolean;
  } & OsProps
>(({ $os }) => {
  return css`
    width: 100%;

    .innovation-umami-product-item {
      width: 100%;
      /* aspect-ratio: 666 / 728; */
      height: calc(100vh - 128px);
      height: calc(100dvh - 128px);
      @media ${responsiveMap.maxLg} {
        height: calc(100vh - 64px);
        aspect-ratio: unset;
      }
    }
    .innovation-umami-product-content {
      height: 100%;
      @media ${responsiveMap.maxLg} {
        height: calc(100vh - 64px);
        height: calc(100dvh - 64px);
        padding: 80px 0 32px;
      }
    }
  `;
});

export const InnovationProductListWrapper = styled.div`
  @media ${responsiveMap.mobile} {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  @media ${responsiveMap.lg} {
    display: grid;
    grid-template-columns: repeat(2, auto);
    row-gap: 16px;
    column-gap: 16px;
    width: 100%;
    justify-content: center;
  }
`;

export const InnovationProductItem = styled.div(() => {
  return css`
    @media ${responsiveMap.mobile} {
      height: -webkit-fill-available;
      height: calc(100vh - 64px);
      flex-shrink: 0;
    }
  `;
});
